import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchTraining({
    commit,
  }, params) {
    return axios.get(`/training?${formatParams(params)}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'training',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
};
